module.exports = __webpack_public_path__ + "img/bandeau_kkbb.f21331c8.png";